import { Icon } from '@pms-digital/design-system';

export type McpCopyResult = { kind: 'copied'; label: string } | { kind: 'failed' };

interface McpCopyStatusProps {
  /** What the last copy did, or `null` once the message has faded. */
  result: McpCopyResult | null;
}

/**
 * The answer to a copy button, written next to it. The live region is always
 * mounted (an empty one announces nothing), so a screen reader hears the text
 * when it appears. Inline rather than a toast: the toast of the design system
 * sits under the modal's overlay.
 */
export function McpCopyStatus({ result }: McpCopyStatusProps) {
  return (
    <output aria-live="polite" className="flex items-center gap-1 text-caption">
      {result?.kind === 'copied' && (
        <span className="inline-flex items-center gap-1 text-success-deep">
          <Icon name="check_circle" size={16} />
          {result.label}
        </span>
      )}
      {result?.kind === 'failed' && (
        <span className="inline-flex items-center gap-1 text-danger-deep">
          <Icon name="error" size={16} />
          Copie impossible : sélectionnez le texte et copiez-le à la main.
        </span>
      )}
    </output>
  );
}
